import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

const ContextualLinksRow = ({ links }) => {
  const intl = useIntl();

  return (
    <p>
      {links.map(({ key, href }, index) => (
        <span key={index}>
          <a href={ href } 
            title={intl.formatMessage({ id: key })} 
            rel="noopener noreferrer" 
            target="_blank">
            <FormattedMessage id={`${key}`} />
          </a>
          {index === links.length - 1 ? '.' : links.length > 1 && index === 0 ? ': ' : ', '}
        </span>
      ))}
    </p>
  );
};

export default ContextualLinksRow;
